import { IPublicClientApplication } from "@azure/msal-browser";

export type TAuthConfig = {
  applicationId: string;
  instance: string;
  tenant: string;
  signInPolicy: string;
  resetPolicy: string;
  scopes: string[];
  redirectUri: string;
};

export type TAuthSession = {
  msalInstance: IPublicClientApplication;
  idToken: string;
  isMobileAuth: boolean;
};

export type TAuthState = {
  msalInstance: IPublicClientApplication | null;
  isLoggedIn: boolean;
  isAuthenticating: boolean;
  idToken: string;
  authError: string | null;
  isMobileAuth: boolean;
};

export type TAuthAdapterCallbacks = {
  onAuthenticated: (session: TAuthSession) => void;
  onError: (error: unknown) => void;
  onLoggedOut: () => void;
};

export interface IAuthAdapter {
  initialize(callbacks: TAuthAdapterCallbacks): Promise<void>;
  login(): Promise<void>;
  logout(): Promise<void>;
  refreshToken(): Promise<string>;
  dispose(): void;
}

export type TAuthContextValue = {
  msalInstance: IPublicClientApplication;
  isLoggedIn: boolean;
  idToken: string;
  authError: string | null;
  isMobileAuth: boolean;
  refreshToken: () => Promise<string>;
  performLoginRedirect: () => Promise<void>;
  logout: () => Promise<void>;
};

export const initialAuthState: TAuthState = {
  msalInstance: null,
  isLoggedIn: false,
  isAuthenticating: true,
  idToken: "",
  authError: null,
  isMobileAuth: false,
};
